import React from 'react';
import moment from 'moment';
import { DatePickerInput } from 'rc-datepicker';
import { Field, Select } from '../Common';
import { connect } from 'react-redux';

class MemoryChargedForm extends React.Component {
    constructor(props) {
        super(props);
	
		const parseDateFromInstant = (dateNaissance) => {
			if (!dateNaissance) return null;
			
			if (moment.isMoment(dateNaissance)) {
				return dateNaissance;
			}
			
			
            if (dateNaissance.epochSecond) {
                return moment.unix(dateNaissance.epochSecond).startOf('day');
            }
            
            if (typeof dateNaissance === 'string' && moment(dateNaissance).isValid()) {
                return moment(dateNaissance).startOf('day');
            }
			
			return null;
		};
	
		const dateNaissance = this.props.memoryChargedData && this.props.memoryChargedData.dateNaissance;
		const date = parseDateFromInstant(dateNaissance);
	
	    this.state = {
            date: date, 
            startDate: moment(),
            calendarFocused: false,
            firstName: this.props.memoryChargedData && this.props.memoryChargedData.prenom ? this.props.memoryChargedData.prenom : '',
            name: this.props.memoryChargedData && this.props.memoryChargedData.nom ? this.props.memoryChargedData.nom : '',
            address: this.props.memoryChargedData && this.props.memoryChargedData.address ? this.props.memoryChargedData.address : '',
            email: this.props.memoryChargedData && this.props.memoryChargedData.email ? this.props.memoryChargedData.email : '',
            telephone: this.props.memoryChargedData && this.props.memoryChargedData.telephone ? this.props.memoryChargedData.telephone : '',
            zipCode: this.props.memoryChargedData && this.props.memoryChargedData.zipCode ? this.props.memoryChargedData.zipCode : '',
            city: this.props.memoryChargedData && this.props.memoryChargedData.city ? this.props.memoryChargedData.city : '',
            codeCountry: this.props.memoryChargedData && this.props.memoryChargedData.codeCountry ? this.props.memoryChargedData.codeCountry : "79",
            error: {
                name: '',
                address: '',
                zipCode: '',
                city: '',
                date: '',
                codeCountry: '',
                telephone: '',

            }
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }


    dateOnChange = (jsDate, dateString) => {
		
        let momentDate = null;
        
        if (jsDate instanceof Date && !isNaN(jsDate)) {
            momentDate = moment(jsDate).startOf('day');
        } else if (moment.isMoment(jsDate) && jsDate.isValid()) {
            momentDate = jsDate.startOf('day');
        }
        
        let obj = {}
        obj.date = (!momentDate || !momentDate.isValid()) ? 'is-invalid' : ''
        
        this.setState(prevState => ({
            date: momentDate,
            error: {
                ...prevState.error,
                ...obj
            }
        }));
    }

    handleChange(value) {
        
        let momentValue = null;
        
        if (moment.isMoment(value) && value.isValid()) {
            momentValue = value;
        } else if (value instanceof Date) {
            momentValue = moment(value);
        } else if (typeof value === 'string') {
            momentValue = moment(value);
        }
        
        this.setState({ date: momentValue })
    }

    onZipCodeChange(key, e) {
        const value = e.target.value;
        if (!isNaN(value)) {
            this.setState(() => ({ [key]: value }));
        }
    }

    handleOnChange(key, e) {
        const value = e.target.value;
        this.setState(() => ({ [key]: value }));
    }

    onSubmit = (e) => {
        e.preventDefault();
        const name = (!this.state.name) ? ' is-invalid' : '';
        const firstName = (!this.state.firstName) ? ' is-invalid' : '';
		const date = (!this.state.date || !moment.isMoment(this.state.date) || !this.state.date.isValid()) ? ' is-invalid' : '';
        const dateToSend = this.state.date ? this.state.date.format('YYYY-MM-DD') : null;
        const email = (!this.state.email) ? ' is-invalid' : '';
        const telephone = (!this.state.telephone) ? ' is-invalid' : '';
        const address = (!this.state.address) ? ' is-invalid' : '';
        const zipCode = (!this.state.zipCode) ? ' is-invalid' : '';
        const city = (!this.state.city) ? ' is-invalid' : '';
        const codeCountry = (!this.state.codeCountry) ? ' is-invalid' : '';
        this.setState(prevState => ({
            error: {
                ...prevState.error,
                name,
                firstName,
                date,
                email,
                telephone,
                address,
                zipCode,
                city,
                codeCountry,

            }
        }))
        if (!name && !firstName && !date && !address && !zipCode && !city && !codeCountry && !email && !telephone)
            this.props.onMemoryChargedSubmit({
                firstName: this.state.firstName,
                name: this.state.name,
                email: this.state.email,
                telephone: this.state.telephone,
                date: dateToSend, 
                address: this.state.address,
                zipCode: this.state.zipCode,
                city: this.state.city,
                codeCountry: this.state.codeCountry,

            });
    }
    back() {

    }
    render() {
        return (
            <form onSubmit={this.onSubmit}>
                <p>

                    Le chargé de mémoire a pour mission d'aviser {this.props.partenaireData.marqueAllianzPartners} de votre décès. Il recevra alors le contenu du recueil et pourra s'assurer
                    que vos dernières volontés soient respectées.
                </p>
                <h4>Pour exécuter mes dernières volontés, je désigne comme Chargé de mémoire </h4>
                <div className="row">
                    <div className="col-sm-5">
                        <img src='/images/b2-page-lg.png' alt="image profil" className="_lg" />
                        <img src='/images/b2-page-sm.png' alt="image profil" className=" _sm" />
                    </div>
                    <div className="col-sm-7 form-container top-form">
                        <Field
                            label="Nom *"
                            type="text"
                            //placeholder="DUPOND"
                            _className={"form-control  " + this.state.error.name}
                            value={this.state.name}
                            onChange={this.handleOnChange.bind(this, "name")}
                            error={this.state.error.name}

                        />
                        <Field
                            label="Prénom *"
                            type="text"
                            //placeholder="ALAIN"
                            _className={"form-control  " + this.state.error.firstName}
                            value={this.state.firstName}
                            onChange={this.handleOnChange.bind(this, "firstName")}
                            error={this.state.error.firstName}

                        />
                        <div className="form-group">
                            <label>Date de naissance *</label>
                            <DatePickerInput
                                onChange={this.dateOnChange}
                                value={this.state.date} 
                                maxDate={moment()}
                                className={'custom-datepicker ' + this.state.error.date}
                                showOnInputClick={true}
                                iconClassName='cal-icon'
                                locale = 'fr'
                            />
                            {this.state.error.date &&
                                <div className="invalid-feedback invalid-date">
                                    Le champ Date de naissance   est obligatoire
                                </div>}
                        </div>
                        <Field
                            label="Email *"
                            type="email"
                            _className={"form-control  " + this.state.error.email}
                            value={this.state.email}
                            onChange={this.handleOnChange.bind(this, "email")}
                            error={this.state.error.email}

                        />

                        <Field
                            label="Numéro de téléphone*"
                            type="text"
                            _className={"form-control  " + this.state.error.telephone}
                            value={this.state.telephone}
                            onChange={this.handleOnChange.bind(this, "telephone")}
                            error={this.state.error.telephone}

                        />
                        <Field
                            label="Adresse *"
                            type="text"
                            _className={"form-control  address" + this.state.error.address}
                            value={this.state.address}
                            onChange={this.handleOnChange.bind(this, "address")}
                            error={this.state.error.address}
                        //placeholder="1 rue de Charles de Gaule"
                        />
                        <Field
                            label="Code postal *"
                            type="text"

                            _className={"form-control  " + this.state.error.zipCode}
                            value={this.state.zipCode}
                            onChange={this.onZipCodeChange.bind(this, "zipCode")}
                            error={this.state.error.zipCode}
                        //placeholder="97860"
                        />
                        <Field
                            label="Ville *"
                            type="text"
                            _className={"form-control  " + this.state.error.city}
                            value={this.state.city}
                            onChange={this.handleOnChange.bind(this, "city")}
                            error={this.state.error.city}
                        //placeholder="MARNY SUR OISE"
                        />
                        <Select
                            label="Pays *"
                            error={this.state.error.codeCountry}
                            _className={"form-control address " + this.state.error.codeCountry}
                            value={this.state.codeCountry}
                            onChange={this.handleOnChange.bind(this, 'codeCountry')}
                            list={this.props.countryData.list}
                            selectType="obj"
                            optionValue="id"
                            optionLabel="libelle"
                        />
                        <h5>Vous devrez informer cette personne de sa mission</h5>
                        <div className="required-txt"> * Champs obligatoires</div>
                    </div>
                    <div className=" col-sm-12 button-container ">
                        <button type="button" onClick={this.props.back} className="btn btn-outline-primary ">Annuler</button>
                        <button type="submit" className="btn btn-primary " >Suivant ></button>
                    </div>
                </div>
            </form>
        )
    }
}


const mapStateToProps = state => {
    return {
        memoryChargedData: state.memoryChargedData,
        countryData: state.countryData,
        partenaireData: state.partenaireData
    }
}

export default connect(mapStateToProps)(MemoryChargedForm);




// WEBPACK FOOTER //
// ./src/components/MemoryChargedPage/MemoryChargedForm.js